









import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CouponExamineApi from '@/api/vip/couponExamine/index'
@Component({
  components: {
  },
})
export default class WriteOff extends AbpBase {
  inputValue: string = ''
  submit() {
    if(!this.inputValue) {
      this.$Message.warning('请输入核销码')
      return
    }
    this.$Modal.confirm({
      title: '提示',
      content: `是否确认核销?`,
      onOk: () => {
        CouponExamineApi.writeOffCoupon(this.inputValue).then(res => {
          console.log('核销结果', res);
          this.$Notice.success({ desc: '核销成功' })
          this.inputValue = ''
          // if(res.data) {
          //   this.$Notice.success({ desc: '核销成功' })
          //   this.inputValue = ''
          // }else {
          //   this.$Notice.success({ desc: '核销失败，未查到该核销码，或已核销' })
          //   this.inputValue = ''
          // }
        }).catch(() => {
          this.$Notice.success({ desc: '核销失败，未查到该核销码，或已核销' })
          this.inputValue = ''
        })
      }
    })
    
  }
}
